import React from 'react';

export interface TooltipHeaderProps {
  icon?: React.ReactNode;
  label?: string;
}

const TooltipHeader = ({ icon, label }: TooltipHeaderProps) => (
  <div className="tooling-tooltip__header ">
    {icon}
    {label && <span>{label}</span>}
  </div>
);

TooltipHeader.displayName = 'ToolingCoverageTooltip.Header';

export default TooltipHeader;
